/**
 * Supabase Browser Client
 * 
 * Uses @supabase/ssr's createBrowserClient for client-side components.
 */

import { createBrowserClient as createSupabaseBrowserClientSSR } from '@supabase/ssr'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || ''
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || ''

/**
 * Create a Supabase browser client for use in Client Components.
 * 
 * @returns Supabase client instance or null if not configured
 */
export function createBrowserClient() {
  if (!supabaseUrl || !supabaseAnonKey) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Supabase credentials not configured. Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY.')
    }
    return null
  }

  return createSupabaseBrowserClientSSR(supabaseUrl, supabaseAnonKey)
}
